import React from "react";
import { connect } from "react-redux";
import { preferredLocationSelector } from "tsi-common-react/src/apps/common/selectors";
import { TDispatchMapper } from "tsi-common-react/src/apps/reducers.interfaces";
import {
    ILocation,
    IRetailStoreWithDistance,
} from "tsi-common-react/src/models/location.interfaces";

import { IReduxState } from "../../reducers.interfaces";
import { FlagshipNearestStores as FlagshipNearestStoresComponent } from "../components/FlagshipNearestStores";
import { Dispatchers } from "../dispatchers";
import { getAllFlagshipStorePages } from "../loaders";
import { ICMSFlagshipStorePage } from "../models.interfaces";
import { flagshipStoreSelector } from "../selectors";

interface IReduxProps {
    stores: IRetailStoreWithDistance[];
    storePages: ICMSFlagshipStorePage[];
    preferredLocation: ILocation | null;
}

interface IOwnProps {
    maxTiles: number;
    includeLocationInfo: boolean;
}

interface IDispatchProps {
    dispatchers: Dispatchers;
}

type IProps = IReduxProps & IOwnProps & IDispatchProps;

interface IState {}

// TODO(ssr, MEDIUM 5 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 5/10 due to async store loading in componentDidMount, Redux connection with dispatchers, and passthrough rendering with multiple props.
class FlagshipNearestStoresContainer extends React.Component<IProps, IState> {
    componentDidMount() {
        this.loadStores();
    }

    private async loadStores() {
        const storePages = await getAllFlagshipStorePages();
        this.props.dispatchers.addFlagshipStorePages(storePages);
    }

    render() {
        return (
            <FlagshipNearestStoresComponent
                stores={this.props.stores}
                storePages={this.props.storePages}
                maxTiles={this.props.maxTiles}
                preferredLocation={this.props.preferredLocation}
                includeLocationInfo={this.props.includeLocationInfo}
            />
        );
    }
}

const mapStateToProps = (
    state: IReduxState,
    ownProps: IOwnProps,
): IReduxProps & IOwnProps => {
    return {
        ...ownProps,
        preferredLocation: preferredLocationSelector(state),
        stores: flagshipStoreSelector(state),
        storePages: Object.values(state.retail.flagshipStorePages),
    };
};

const mapDispatchToProps: TDispatchMapper<IDispatchProps> = (dispatch) => {
    const dispatchers = new Dispatchers(dispatch);
    return {
        dispatchers: dispatchers,
    };
};

export const FlagshipNearestStores = connect(
    mapStateToProps,
    mapDispatchToProps,
)(FlagshipNearestStoresContainer);
